<template>
  <header class="sticky-menu" v-if="!loading">
    <!-- <NotiBar
      :noti.sync="shopInfo.noti"
    ></NotiBar>-->
    <router-link :to="{ name: 'Dashboard' }" class="logo-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 820 200" width="160" fill="#fff" ><path class="cls-1" d="M208.56,65.75c20.87,0,38.33,13,42.23,31.59H236.27c-3.67-11-14.53-18.06-27.35-18.06-17.33,0-29.54,12.57-29.54,30.62s12,30.73,29.54,30.73c13.55,0,24.66-7.68,27.83-19.27H206.36V109.29H252c-.36,26.1-18.06,44.88-43.09,44.88S165.1,135.51,165.1,109.9C165.1,84.53,183.53,65.75,208.56,65.75Z"/><path class="cls-1" d="M259.46,119.66c0-19.76,14.65-34.52,33.93-34.52,20.15,0,33.57,15.49,33.57,34.64,0,1.46-.12,3-.24,4.51H273.25c1.59,10.61,9.28,17.2,20.14,17.2,7.82,0,14.29-3.66,17.7-9.64h14.29c-5.25,13.91-17.34,22.32-32,22.32C274.11,154.17,259.46,139.29,259.46,119.66Zm54-6.35c-2.44-10-10-16-20-16-10.25,0-17.57,6.09-19.89,16Z"/><path class="cls-1" d="M338.93,152.59V86.72h9.64l2.32,8.54a26.16,26.16,0,0,1,20.51-10c8.91,0,16,4.39,19.77,11.47a26,26,0,0,1,21.49-11.47c13.91,0,23.31,10.49,23.31,25.49v41.84H422.42V114.05c0-10.62-4.63-16.71-12.81-16.71-8.79,0-15.51,8-15.51,19.27v36H380.8V114.05c0-10.62-4.52-16.71-12.82-16.71-8.79,0-15.5,8-15.5,19.27v36Z"/><path class="cls-1" d="M453.06,152.59V67.21h31.62c16.48,0,29.05,12,29.05,28.17s-12.45,28.18-29.05,28.18H467.1v29Zm14-42.33H484c9.15,0,15.62-6.22,15.62-14.88S493.1,80.5,484,80.5H467.1Z"/><path class="cls-1" d="M519.59,119.66c0-19.88,14.77-34.52,34.43-34.52a33.21,33.21,0,0,1,24,9.76l1.59-8.18h10.5v65.87h-11l-1.34-8.05a32.75,32.75,0,0,1-23.8,9.63C534.36,154.17,519.59,139.41,519.59,119.66Zm13.8,0A21.1,21.1,0,0,0,555,141.24c12.45,0,21.49-9.14,21.49-21.58s-9-21.59-21.49-21.59A21.1,21.1,0,0,0,533.39,119.66Z"/><path class="cls-1" d="M602.11,118a32.9,32.9,0,0,1,56.64-22.69l2.2-8.54h8.91v57.21c0,21.1-12.57,33.9-33,33.9-16.84,0-28.81-8.78-32.22-23.29h13.55c2.56,7.32,10.25,11.22,18.55,11.22,11.48,0,19.78-7.44,19.78-20v-2.93a33.42,33.42,0,0,1-21.85,7.81A32.22,32.22,0,0,1,602.11,118Zm13.8,0c0,11.46,8.66,20.12,20.38,20.12s20.27-8.54,20.27-20.12S648,97.7,636.29,97.7,615.91,106.36,615.91,118Z"/><path class="cls-1" d="M681.83,119.66c0-19.76,14.64-34.52,33.93-34.52,20.14,0,33.57,15.49,33.57,34.64,0,1.46-.12,3-.24,4.51H695.62c1.59,10.61,9.28,17.2,20.14,17.2,7.81,0,14.28-3.66,17.7-9.64h14.28c-5.25,13.91-17.33,22.32-32,22.32C696.47,154.17,681.83,139.29,681.83,119.66Zm53.95-6.35c-2.44-10-10-16-20-16-10.25,0-17.58,6.09-19.9,16Z"/><path class="cls-1" d="M769.59,131.73c.37,7,6.23,10.49,14.17,10.49,7.2,0,12.81-3.05,12.81-8.54,0-6.22-7.08-7.68-15.13-9-11-1.83-23.93-4.39-23.93-19.64,0-11.83,10.25-19.88,25.51-19.88s25.27,8.29,25.51,21.1H795.72c-.25-6.34-5-9.64-12.94-9.64-7.57,0-12.21,3.18-12.21,7.93,0,5.86,6.84,7.08,14.77,8.3,11.11,2,24.66,4,24.66,20.24,0,12.81-10.74,21.1-26.73,21.1s-26.61-8.78-27-22.44Z"/><path class="cls-1" d="M150,22.22,10.76,65.75A1.11,1.11,0,0,0,10,67.13l10.74,35.29a1,1,0,0,0,1.32.72l102.15-32a19.21,19.21,0,0,0,11.35-9.53,226.48,226.48,0,0,0,15.64-38A1,1,0,0,0,150,22.22Z"/><path class="cls-1" d="M116.58,83.26l-86.5,27a1,1,0,0,0-.62,1.18l9.1,29.81a.93.93,0,0,0,1.13.61l55.16-17.26a16.43,16.43,0,0,0,9.61-8,186.5,186.5,0,0,0,13.19-32.17A.89.89,0,0,0,116.58,83.26Z"/><path class="cls-1" d="M83.68,137.77,47.63,149.06a.8.8,0,0,0-.51,1l7.67,25.2a.75.75,0,0,0,1,.51l9.57-3a13.94,13.94,0,0,0,8.13-6.82A157,157,0,0,0,84.6,138.75.73.73,0,0,0,83.68,137.77Z"/></svg>
      <div class="logo-title" v-if="shopInfo.developmentStore">
        DEVELOPMENT
      </div>
    </router-link>

    <UniversalSearch v-if="!isGemPagesV7"/>
    <!-- GetHelp Module -->
    <!-- <div class="right-item d-none d-sm-flex" v-if="isShowIcon">
      <div class="gethep_top-icon button d-flex" @click="toggleGetHelp" :class="{'showup': isShowIcon}">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.0711 2.92894C15.1823 1.04016 12.6711 0 10 0C7.3289 0 4.81768 1.04016 2.92894 2.92894C1.04016 4.81768 0 7.3289 0 10C0 12.6711 1.04016 15.1823 2.92894 17.0711C4.81768 18.9598 7.3289 20 10 20C12.6711 20 15.1823 18.9598 17.0711 17.0711C18.9598 15.1823 20 12.6711 20 10C20 7.3289 18.9598 4.81768 17.0711 2.92894ZM18.7961 9.37008H15.5152C15.3033 7.50248 14.1611 5.91311 12.5644 5.07787L13.6511 1.97311C16.5158 3.28134 18.5628 6.07905 18.7961 9.37008ZM10 14.3701C7.59031 14.3701 5.62992 12.4097 5.62992 10C5.62992 7.59031 7.59031 5.62992 10 5.62992C12.4097 5.62992 14.3701 7.59031 14.3701 10C14.3701 12.4097 12.4097 14.3701 10 14.3701ZM12.5457 1.55622L11.4645 4.64528C10.9978 4.51748 10.5068 4.44882 10 4.44882C9.43909 4.44882 8.89748 4.53276 8.38669 4.68819L7.0389 1.69311C7.96488 1.36201 8.96165 1.1811 10 1.1811C10.8848 1.1811 11.7393 1.31264 12.5457 1.55622ZM5.95595 2.16461L7.29996 5.1513C5.77445 6.00417 4.69067 7.55583 4.4848 9.37012H1.20386C1.42642 6.23161 3.29835 3.54181 5.95595 2.16461ZM1.19882 10.5512H4.47614C4.58071 11.607 4.98244 12.5766 5.5961 13.3754L3.27421 15.6972C2.08079 14.2905 1.32 12.5061 1.19882 10.5512ZM4.0963 16.5455L6.41075 14.231C7.37925 15.0539 8.63256 15.5512 10 15.5512C11.2915 15.5512 12.4815 15.1078 13.4256 14.3653L15.796 16.641C14.245 17.9965 12.2168 18.8189 10 18.8189C7.73154 18.8189 5.66059 17.9577 4.0963 16.5455ZM16.6319 15.8063L14.2721 13.5407C14.96 12.712 15.412 11.6809 15.5239 10.5512H18.8012C18.6768 12.557 17.8793 14.3833 16.6319 15.8063Z" fill="#E2E2E2"/>
        </svg>
      </div>
    </div> -->

    <!-- Old help (? dropdown) -->
    <div class="d-flex">
      <div class="right-item d-none d-sm-flex">
        <!-- <span v-if="!isOpenHelpCenter" class="tooltip tooltip-top">{{ $t("generals.helpCenter.toolTips")}}</span> -->
        <!-- <div class="right-item" @click="openHelpCenter"> -->
        <div class="button d-flex" :class="{ 'button-disabled': isOpenHelpCenter }" v-popover:tooltip.bottomsidebar="$t('generals.helpCenter.toolTips')" @click.stop="openHelpCenter" id="help-center">
          <i class="icon icon-help"></i>
        </div>
        <!-- <div class="noti-num noti-num-small d-flex align-item-center clickable" :class="{ 'button-disabled': isOpenHelpCenter }" v-if="tickets && unreadTickets > 0" @click.stop="openHelpCenter"></div> -->
        <div class="drop-down" v-clickaway="closeHelpCenter" :class="{ active: isOpenHelpCenter }">
          <div class="drop-down-menu no-hover">
            <span class="typo-button14 weight-500">{{ supportDropdownTitle }}</span>
          </div>
          <a target="_blank" :href="emailSupportHref" class="drop-down-menu d-flex align-items-center" v-if="isNotBusiness">
            <i class="icon icon-mail mr-2"></i>
            <span class="typo-button14 weight-500">{{ $t("support.emailSupport") }}</span>
          </a>
          <a class="drop-down-menu d-flex align-items-center justify-content-between" @click="openLiveChat()">
            <div class="d-flex align-items-center">
              <i class="icon icon-chat mr-2"></i>
              <span class="typo-button14 weight-500">{{ $t("generals.helpCenter.liveChat") }}</span>
            </div>
            <div class="d-flex align-items-center" v-if="isNotBusiness">
              <img class="drop-down__diamond mr-4px" :src="require('@/core/assets/pricing/diamond-lighting.svg')" />
              <p class="txt-primary-400 drop-down__plan">{{ $t("support.business") }}</p>
            </div>
          </a>
          <!-- <div class="drop-down-menu">
            <span class="typo-button14 weight-500" >Help Center</span>
          </div>-->
          <a @click="openGuide" v-if="!isGemPagesV7" class="drop-down-menu d-flex align-items-center">
            <i class="icon icon-rocket mr-2"></i>
            <span class="typo-button14 weight-500">{{ $t("generals.helpCenter.getStarted") }}</span>
          </a>
          <a @click="closeHelpCenter" href="https://help.gempages.net/" class="drop-down-menu d-flex align-items-center" target="_blank">
            <i class="icon icon-help mr-2"></i>
            <span class="typo-button14 weight-500">{{ $t("generals.helpCenter.title") }}</span>
          </a>
          <router-link v-if="!isGemPagesV7" :to="{ name: 'Tutorials' }" class="drop-down-menu d-flex align-items-center">
            <svg class="mr-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.8751 10.6501C1.54373 10.6501 1.2751 10.9187 1.2751 11.2501V17.5001C1.2751 17.8315 1.54373 18.1001 1.8751 18.1001H13.1251C13.4565 18.1001 13.7251 17.8315 13.7251 17.5001V11.2501C13.7251 10.9187 13.4565 10.6501 13.1251 10.6501H1.8751ZM-0.0249023 11.2501C-0.0249023 10.2008 0.825757 9.3501 1.8751 9.3501H13.1251C14.1744 9.3501 15.0251 10.2008 15.0251 11.2501V17.5001C15.0251 18.5494 14.1744 19.4001 13.1251 19.4001H1.8751C0.825757 19.4001 -0.0249023 18.5494 -0.0249023 17.5001V11.2501Z" fill="#E2E2E2" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.3024 10.6116C18.4949 10.5392 18.7021 10.5145 18.9063 10.5395C19.1107 10.5646 19.3059 10.6389 19.4753 10.756C19.6447 10.873 19.7832 11.0294 19.8789 11.2117C19.9747 11.3939 20.0248 11.5967 20.0251 11.8026L20.0251 17.5001C20.025 17.706 19.975 17.9091 19.8795 18.0915C19.7839 18.2739 19.6456 18.4304 19.4763 18.5477C19.3071 18.665 19.112 18.7396 18.9076 18.765C18.7033 18.7904 18.4958 18.766 18.303 18.6938L14.1469 17.1354C13.8932 17.0402 13.7251 16.7977 13.7251 16.5268V12.7784C13.7251 12.5075 13.8932 12.2649 14.1469 12.1698L18.3024 10.6116C18.3026 10.6115 18.3022 10.6117 18.3024 10.6116ZM18.7251 11.8415V17.4637L15.0251 16.0763V13.2289L18.7251 11.8415Z" fill="#E2E2E2" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.1001 12.5001C3.1001 12.1411 3.39111 11.8501 3.7501 11.8501H10.6251C10.9841 11.8501 11.2751 12.1411 11.2751 12.5001C11.2751 12.8591 10.9841 13.1501 10.6251 13.1501H3.7501C3.39111 13.1501 3.1001 12.8591 3.1001 12.5001Z" fill="#E2E2E2" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.7501 1.9001C2.38319 1.9001 1.2751 3.00819 1.2751 4.3751C1.2751 5.742 2.38319 6.8501 3.7501 6.8501C5.117 6.8501 6.2251 5.742 6.2251 4.3751C6.2251 3.00819 5.117 1.9001 3.7501 1.9001ZM-0.0249023 4.3751C-0.0249023 2.29022 1.66522 0.600098 3.7501 0.600098C5.83497 0.600098 7.5251 2.29022 7.5251 4.3751C7.5251 6.45997 5.83497 8.1501 3.7501 8.1501C1.66522 8.1501 -0.0249023 6.45997 -0.0249023 4.3751Z" fill="#E2E2E2" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8751 3.1501C10.8534 3.1501 10.0251 3.97837 10.0251 5.0001C10.0251 6.02182 10.8534 6.8501 11.8751 6.8501C12.8968 6.8501 13.7251 6.02182 13.7251 5.0001C13.7251 3.97837 12.8968 3.1501 11.8751 3.1501ZM8.7251 5.0001C8.7251 3.2604 10.1354 1.8501 11.8751 1.8501C13.6148 1.8501 15.0251 3.2604 15.0251 5.0001C15.0251 6.73979 13.6148 8.1501 11.8751 8.1501C10.1354 8.1501 8.7251 6.73979 8.7251 5.0001Z" fill="#E2E2E2" />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <span class="typo-button14 weight-500">{{ $t("generals.tutorials") }}</span>
          </router-link>
          <a @click="closeHelpCenter" href="https://feedback.gempages.net/" class="drop-down-menu d-flex align-items-center" target="_blank">
            <svg class="mr-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.0514 3.13457C14.1556 2.76355 13.1112 3.18434 12.7344 4.09431L10.039 10.6015C10.0071 10.6785 9.99449 10.7622 10.0022 10.8452L10.2529 13.535C10.2913 13.947 10.7755 14.1428 11.0902 13.8818L13.1695 12.1571C13.2336 12.1038 13.2838 12.0358 13.3157 11.9588C13.3885 11.783 15.9773 5.5331 16.0111 5.45155C16.3867 4.54476 15.9551 3.5089 15.0514 3.13457ZM15.0643 5.05942L14.768 5.77471L13.3849 5.2018L13.6812 4.48655C13.8392 4.10518 14.2778 3.92344 14.6592 4.08143C15.0412 4.23963 15.2226 4.67727 15.0643 5.05942ZM12.4175 11.4494L11.1832 12.4732L11.0344 10.8765L12.9927 6.14864L14.3758 6.72155L12.4175 11.4494Z" fill="#E2E2E2" />
              <path d="M9 4.65C9 4.29103 8.81392 4 8.5844 4H4.4156C4.18608 4 4 4.29103 4 4.65C4 5.00897 4.18608 5.3 4.4156 5.3H8.58437C8.81392 5.3 9 5.00897 9 4.65Z" fill="#E2E2E2" />
              <path d="M4.40415 8.8H7.59585C7.81905 8.8 8 8.50897 8 8.15C8 7.79103 7.81905 7.5 7.59585 7.5H4.40415C4.18095 7.5 4 7.79103 4 8.15C4 8.50897 4.18095 8.8 4.40415 8.8Z" fill="#E2E2E2" />
              <path d="M7.61783 11H4.38217C4.17111 11 4 11.291 4 11.65C4 12.009 4.17111 12.3 4.38217 12.3H7.61783C7.82889 12.3 8 12.009 8 11.65C8 11.291 7.82889 11 7.61783 11Z" fill="#E2E2E2" />
              <rect x="1.65" y="0.65" width="16.7" height="16.7" rx="2.35" stroke="#E2E2E2" stroke-width="1.3" />
            </svg>
            <span class="typo-button14 weight-500">{{ $t("generals.helpCenter.feedback") }}</span>
          </a>
          <!-- <div class="drop-down-menu" @click="handleOpenFeedback">
            <i class="icon icon-feedback mr-2"></i>
            <span class="typo-button14 weight-500">{{ $t("generals.giveFeedback") }}</span>
          </div> -->
        </div>
      </div>
      <div class="right-item d-none d-sm-flex">
        <!-- <div class="right-item" v-clickaway="closeNotiCenter"  @click="openNotiCenter" > -->
        <!-- <span v-if="!isOpenNotiCenter" class="tooltip tooltip-top">{{ $t("generals.notiCenter.toolTips")}}</span> -->
        <div class="button d-flex" :class="{ 'button-disabled': notiBar.isOpen }" v-popover:tooltip.bottomsidebar="$t('generals.notiCenter.toolTips')" @click="openNoti">
          <i class="icon icon-notification"></i>
        </div>
        <div class="noti-num d-flex align-item-center clickable" :class="{ 'button-disabled': isOpenHelpCenter }" v-if="notiBar.noti_list_unread && notiBar.noti_list_unread > 0" @click.stop="openNoti">
          <span class="text-dark-high">{{ notiBar.noti_list_unread }}</span>
          <!-- <span class="text-dark-high" v-else></span> -->
        </div>
      </div>
      <div class="right-item d-none d-sm-flex">
        <router-link :to="{ name: 'AccountSettings' }" class="button d-flex" :class="{'button-disabled': $route.name === 'AccountSettings' }" v-popover:tooltip.bottomsidebar="$tc('generals.setting', 2)">
          <i class="icon icon-settings"></i>
        </router-link>
      </div>
      <div class="user-info">
        <div class="button" :class="{ 'button-disabled': isOpenUserInfo }" v-popover:tooltip.bottomsidebar="$tc('generals.clickToSeeMore')" @click="openUserInfo">
          <!-- <div class="avatar">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M15.182 6.56802C13.4246 4.81066 10.5754 4.81066 8.81802 6.56802C7.06066 8.32537 7.06066 11.1746 8.81802 12.932C10.5754 14.6893 13.4246 14.6893 15.182 12.932C16.9393 11.1746 16.9393 8.32537 15.182 6.56802ZM16.2426 5.50736C13.8995 3.16421 10.1005 3.16421 7.75736 5.50736C5.41421 7.8505 5.41421 11.6495 7.75736 13.9926C10.1005 16.3358 13.8995 16.3358 16.2426 13.9926C18.5858 11.6495 18.5858 7.8505 16.2426 5.50736Z" fill="#E2E2E2" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.60139 20.3009C8.71319 16.2148 15.3588 16.2356 19.4449 20.3474L18.381 21.4047C14.8788 17.8806 9.18291 17.8627 5.65872 21.3649L5.65872 21.3649M5.65872 21.3649L5.6189 21.4047C5.32693 21.6985 4.85206 21.7 4.55825 21.408C4.26444 21.116 4.26295 20.6412 4.55493 20.3474L4.60139 20.3009L4.60139 20.3009" fill="#E2E2E2" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M19.4246 4.57538C15.3241 0.474873 8.67589 0.474873 4.57538 4.57538C0.474873 8.67589 0.474873 15.3241 4.57538 19.4246C8.67589 23.5251 15.3241 23.5251 19.4246 19.4246C23.5251 15.3241 23.5251 8.67589 19.4246 4.57538ZM20.4853 3.51472C15.799 -1.17157 8.20101 -1.17157 3.51472 3.51472C-1.17157 8.20101 -1.17157 15.799 3.51472 20.4853C8.20101 25.1716 15.799 25.1716 20.4853 20.4853C25.1716 15.799 25.1716 8.20101 20.4853 3.51472Z" fill="#E2E2E2" />
              <defs>
                <clipPath id="clip0">
                  <path d="M0 0H24V24H0V0Z" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div> -->
          <div class="user-detail">
            <div class="user-name">
              <span class="typo-heading16 typo-medium">{{ shopInfo.firstName + " " + shopInfo.lastName }}</span>
            </div>
            <div class="shop-domain">
              <span class="typo-paragraph12 typo-regular">{{ shopInfo.shopifyDomain }}</span>
            </div>
          </div>
        </div>
        <div class="drop-down drop-down-edge" v-clickaway="closeUserInfo" :class="{ active: isOpenUserInfo }">
          <!-- <router-link :to="{ name: 'AccountSettings' }" class="drop-down-menu no-hover">
            <span class="typo-button14 weight-500">{{ $t("generals.account.title") }}</span>
          </router-link> -->
          <div class="drop-down-menu no-hover d-none"></div>
          <router-link :to="{ name: 'AgencyDashboard' }" v-if="agencyLogged" class="drop-down-menu d-flex align-items-center first-child">
            <svg class="mr-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.875 10C2.22018 10 2.5 10.2798 2.5 10.625V18.125C2.5 18.4702 2.77982 18.75 3.125 18.75H16.875C17.2202 18.75 17.5 18.4702 17.5 18.125V10.625C17.5 10.2798 17.7798 10 18.125 10C18.4702 10 18.75 10.2798 18.75 10.625V18.125C18.75 19.1605 17.9105 20 16.875 20H3.125C2.08947 20 1.25 19.1605 1.25 18.125V10.625C1.25 10.2798 1.52982 10 1.875 10Z" fill="#E2E2E2" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M2.37677 1.52845e-07C2.37681 1.52845e-07 2.37674 1.52845e-07 2.37677 1.52845e-07H17.6233C18.2093 -0.000287976 18.7168 0.406817 18.8435 0.978988L19.9851 6.11438C19.995 6.15891 20 6.20439 20 6.25C20 7.63071 18.8807 8.75 17.5 8.75C16.7533 8.75 16.0831 8.42265 15.625 7.90364C15.1669 8.42265 14.4967 8.75 13.75 8.75C13.0033 8.75 12.3331 8.42265 11.875 7.90364C11.4169 8.42265 10.7467 8.75 10 8.75C9.25332 8.75 8.58309 8.42265 8.125 7.90364C7.66691 8.42265 6.99668 8.75 6.25 8.75C5.50332 8.75 4.83309 8.42265 4.375 7.90364C3.91691 8.42265 3.24668 8.75 2.5 8.75C1.11929 8.75 1.78814e-07 7.63071 0 6.25C0 6.20442 0.00498682 6.15897 0.0148714 6.11447L1.1557 0.978638C1.28359 0.407157 1.79117 -4.93786e-05 2.37677 1.52845e-07ZM2.37575 1.25065L1.2515 6.31182C1.28372 6.97346 1.83037 7.5 2.5 7.5C3.19036 7.5 3.75 6.94036 3.75 6.25L5 6.25C5 6.94036 5.55964 7.5 6.25 7.5C6.94036 7.5 7.5 6.94036 7.5 6.25C7.5 5.90482 7.77982 5.625 8.125 5.625C8.47018 5.625 8.75 5.90482 8.75 6.25C8.75 6.94036 9.30964 7.5 10 7.5C10.6904 7.5 11.25 6.94036 11.25 6.25C11.25 5.90482 11.5298 5.625 11.875 5.625C12.2202 5.625 12.5 5.90482 12.5 6.25C12.5 6.94036 13.0596 7.5 13.75 7.5C14.4404 7.5 15 6.94036 15 6.25C15 5.90482 15.2798 5.625 15.625 5.625C15.9702 5.625 16.25 5.90482 16.25 6.25C16.25 6.94036 16.8096 7.5 17.5 7.5C18.1696 7.5 18.7163 6.97348 18.7485 6.31186L17.6233 1.25C17.6228 1.25 17.6224 1.25 17.622 1.25H2.37667C2.37663 1.25 2.3767 1.25 2.37667 1.25C2.37629 1.25 2.37585 1.25029 2.37575 1.25065C2.37575 1.25066 2.37575 1.25064 2.37575 1.25065Z" fill="#E2E2E2" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M6.875 13.75C6.875 12.0241 8.27411 10.625 10 10.625C11.7259 10.625 13.125 12.0241 13.125 13.75V19.375C13.125 19.7202 12.8452 20 12.5 20H7.5C7.15482 20 6.875 19.7202 6.875 19.375V13.75ZM10 11.875C8.96447 11.875 8.125 12.7145 8.125 13.75V18.75H11.875V13.75C11.875 12.7145 11.0355 11.875 10 11.875Z" fill="#E2E2E2" />
            </svg>

            <span class="typo-button14 weight-500">{{ $t("agency.storeManager") }}</span>
          </router-link>
          <a v-if="agencyLogged" @click="openSwitchAgencyMenu" class="drop-down-menu d-flex align-items-center">
            <svg class="mr-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.625 10C5.625 9.65482 5.90482 9.375 6.25 9.375H19.375C19.7202 9.375 20 9.65482 20 10C20 10.3452 19.7202 10.625 19.375 10.625H6.25C5.90482 10.625 5.625 10.3452 5.625 10Z" fill="#E2E2E2" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.81694 6.43638C10.061 6.68046 10.061 7.07619 9.81694 7.32027L7.13388 10.0033L9.81694 12.6864C10.061 12.9305 10.061 13.3262 9.81694 13.5703C9.57286 13.8143 9.17714 13.8143 8.93306 13.5703L5.80806 10.4453C5.56398 10.2012 5.56398 9.80546 5.80806 9.56138L8.93306 6.43638C9.17714 6.19231 9.57286 6.19231 9.81694 6.43638Z" fill="#E2E2E2" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.72973 0.625775C1.74009 0.625258 1.75047 0.625 1.76084 0.625H11.9883C11.9987 0.625 12.0091 0.625258 12.0195 0.625775C13.0162 0.675459 13.7866 1.51725 13.75 2.51267V6.25C13.75 6.59518 13.4702 6.875 13.125 6.875C12.7798 6.875 12.5 6.59518 12.5 6.25V2.5C12.5 2.4906 12.5002 2.48121 12.5006 2.47182C12.5147 2.16128 12.2785 1.89715 11.97 1.875H1.77922C1.47099 1.89714 1.23513 2.16113 1.24935 2.47137C1.24979 2.48091 1.25001 2.49045 1.25001 2.5V17.5C1.25001 17.5094 1.2498 17.5188 1.24937 17.5282C1.23536 17.8385 1.47119 18.1026 1.77946 18.125H11.97C12.2785 18.1029 12.5147 17.8387 12.5006 17.5282C12.5002 17.5188 12.5 17.5094 12.5 17.5V13.75C12.5 13.4048 12.7798 13.125 13.125 13.125C13.4702 13.125 13.75 13.4048 13.75 13.75V17.4873C13.7866 18.4828 13.0162 19.3245 12.0195 19.3742C12.0091 19.3747 11.9987 19.375 11.9883 19.375H1.76084C1.75032 19.375 1.7398 19.3747 1.72929 19.3742C0.733031 19.3239 -0.0365959 18.4823 9.50345e-06 17.4873V2.51286C-0.0371687 1.51753 0.732983 0.675457 1.72973 0.625775Z" fill="#E2E2E2" />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>

            <span class="typo-button14 weight-500">{{ $t("agency.switchStore") }}</span>
          </a>
          <!-- <a target="_blank" :href="'https://'+shopInfo.shopifyDomain+'/admin'" class="drop-down-menu no-hover">
            <span
              class="typo-heading16 typo-medium d-block"
            >{{shopInfo.firstName + " " + shopInfo.lastName}}</span>
            <span class="typo-paragraph12 typo-regular">{{shopInfo.shopifyDomain}}</span>
          </a>-->
          <!-- <div class="drop-down-menu">
            <span class="typo-button14 weight-500" >Help Center</span>
          </div>-->
          <!-- <router-link :to="{ name: 'AccountSettings' }" @click.native="closeUserInfo" class="drop-down-menu d-flex align-items-center">
            <i class="icon icon-acc-settings mr-2"></i>
            <span class="typo-button14 weight-500">{{ $t("accountSettings.headerTitle") }}</span>
          </router-link>
          <router-link :to="{ name: 'StoreSettings' }" @click.native="closeUserInfo" class="drop-down-menu d-flex align-items-center">
            <svg class="ico mr-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.4 7C12.7 7 12 6.6 11.6 6.1C11.1 6.6 10.5 6.9 9.7 7C9 6.9 8.3 6.6 7.9 6.1C7.5 6.6 6.8 6.9 6.1 7C5.4 7 4.7 6.6 4.3 6.1C3.8 6.6 3.2 6.9 2.4 7C1.3 7 0.400002 6.3 0.100002 5.3C1.52737e-06 4.8 1.52737e-06 4.3 0.100002 3.8L1.1 0.8C1.3 0.4 1.8 0 2.4 0H13.4C13.9 0 14.4 0.4 14.6 0.9L15.6 3.8C15.8 4.2 15.8 4.7 15.6 5.2C15.4 6.2 14.5 6.9 13.4 7ZM12.2 4.5C12.2 5.2 12.8 5.7 13.4 5.7C13.9 5.7 14.3 5.3 14.5 4.8C14.6 4.6 14.6 4.4 14.5 4.2L13.5 1.2V0.5V1.1H2.5L1.4 4.1C1.3 4.3 1.3 4.5 1.4 4.7C1.6 5.2 2 5.6 2.5 5.6C3.1 5.6 3.7 5 3.7 4.4C3.7 4.3 3.7 4.3 3.7 4.2C3.7 3.9 4 3.6 4.3 3.6C4.6 3.6 4.9 3.9 4.9 4.2C4.9 4.3 4.9 4.3 4.9 4.4C4.9 5.1 5.5 5.6 6.1 5.6C6.7 5.6 7.2 5 7.3 4.4C7.3 4.3 7.3 4.3 7.3 4.2C7.3 3.9 7.6 3.6 7.9 3.6C8.2 3.6 8.5 3.9 8.5 4.2C8.5 4.3 8.5 4.3 8.5 4.4C8.5 5.1 9.1 5.6 9.7 5.6C10.3 5.6 10.8 5 10.9 4.4C10.9 4.3 10.9 4.3 10.9 4.2C10.9 3.9 11.2 3.6 11.5 3.6C11.8 3.6 12.1 3.9 12.1 4.2C12.2 4.4 12.2 4.5 12.2 4.5Z" fill="currentColor" />
              <path d="M7.6 15.3H2.7C1.8 15.3 1 14.6 1 13.6V6.19998C1 5.89998 1.3 5.59998 1.6 5.59998C1.9 5.59998 2.2 5.89998 2.2 6.19998V13.6C2.2 13.8 2.4 14 2.6 14H7.5C7.8 14 8.1 14.3 8.1 14.6C8.1 14.9 8 15.3 7.6 15.3Z" fill="currentColor" />
              <path d="M14.4 15.6C13.4 15.6 12.5 14.8 12.5 13.7C12.5 12.6 13.3 11.8 14.4 11.8C15.5 11.8 16.3 12.6 16.3 13.7C16.3 14.8 15.4 15.6 14.4 15.6ZM14.4 13.1C14.1 13.1 13.8 13.4 13.8 13.7C13.8 14 14.1 14.3 14.4 14.3C14.7 14.3 15 14 15 13.7C15 13.4 14.7 13.1 14.4 13.1Z" fill="currentColor" />
              <path d="M14.4 20C14 20 13.7 19.9 13.4 19.7C13.1 19.5 12.9 19.2 12.8 18.8L12.4 17.6C12.4 17.6 12.4 17.5 12.3 17.5H12.2L11 17.8C10.6 17.9 10.3 17.8 9.9 17.7C9.6 17.6 9.3 17.3 9.1 17C8.9 16.7 8.8 16.3 8.9 15.9C9 15.5 9.1 15.2 9.4 14.9L10.3 14L10.4 13.9C10.4 13.8 10.4 13.8 10.3 13.8L9.4 12.9C9.1 12.6 9 12.3 8.9 11.9C8.9 11.5 8.9 11.2 9.1 10.8C9.3 10.5 9.6 10.2 9.9 10.1C10.2 9.99999 10.6 9.89999 11 9.99999L12.2 10.3H12.3L12.4 10.2L12.8 8.99999C12.9 8.59999 13.1 8.29999 13.4 8.09999C13.7 7.89999 14.1 7.79999 14.4 7.79999C14.8 7.79999 15.1 7.89999 15.4 8.09999C15.7 8.29999 15.9 8.59999 16 8.99999L16.4 10.2C16.4 10.2 16.4 10.3 16.5 10.3H16.6L17.8 9.99999C18.2 9.89999 18.5 9.99999 18.9 10.1C19.2 10.3 19.5 10.5 19.7 10.8C20 11 20 11.3 20 11.7C20 12.1 19.8 12.4 19.5 12.7L18.6 13.6L18.5 13.7C18.5 13.8 18.5 13.8 18.6 13.8L19.5 14.7C19.8 15 19.9 15.3 20 15.7C20 16.1 20 16.4 19.8 16.8C19.6 17.1 19.3 17.4 19 17.5C18.7 17.7 18.3 17.7 17.9 17.6L16.7 17.3C16.6 17.3 16.6 17.3 16.6 17.3L16.5 17.4L16 18.8C15.9 19.2 15.7 19.5 15.4 19.7C15.1 19.9 14.7 20 14.4 20ZM12.2 16.2C12.5 16.2 12.7 16.3 12.9 16.4C13.2 16.6 13.5 16.9 13.6 17.2L14 18.4C14 18.5 14.1 18.6 14.2 18.7C14.4 18.8 14.6 18.8 14.8 18.7C14.9 18.6 14.9 18.5 15 18.5L15.4 17.3C15.5 16.9 15.7 16.6 16.1 16.5C16.4 16.3 16.8 16.3 17.2 16.3L18.4 16.6C18.5 16.6 18.6 16.6 18.7 16.6C18.8 16.6 18.9 16.5 18.9 16.4C18.9 16.3 19 16.2 19 16.1C19 16 18.9 15.9 18.9 15.8L18 14.9C17.7 14.6 17.6 14.3 17.6 13.9C17.6 13.5 17.7 13.2 18 12.9L18.9 12C19 11.9 19 11.8 19 11.7C19 11.6 19 11.5 18.9 11.4C18.8 11.3 18.8 11.2 18.7 11.2C18.6 11.2 18.5 11.1 18.4 11.2L17.2 11.5C16.8 11.6 16.5 11.5 16.1 11.3C15.8 11.1 15.5 10.8 15.4 10.5L15 9.29999C15 9.19999 14.9 9.09999 14.8 9.09999C14.7 8.99999 14.6 8.99999 14.5 8.99999C14.4 8.99999 14.3 8.99999 14.2 9.09999C14 8.89999 13.9 8.99999 13.9 9.09999L13.5 10.3C13.4 10.7 13.2 10.9 12.8 11.1C12.5 11.3 12.1 11.3 11.7 11.3L10.6 11C10.5 11 10.4 11 10.3 11C10.2 11 10.1 11.1 10.1 11.2C10 11.3 10 11.4 10 11.5C10 11.6 10.1 11.7 10.1 11.8L11 12.7C11.3 13 11.4 13.3 11.4 13.7C11.4 14.1 11.3 14.4 11 14.7L10.1 15.6C10 15.7 10 15.8 10 15.9C10 16 10 16.1 10.1 16.2C10.2 16.3 10.2 16.4 10.3 16.4C10.4 16.4 10.5 16.5 10.6 16.4L11.8 16.1C11.9 16.2 12 16.2 12.2 16.2Z" fill="currentColor" />
            </svg>
            <span class="typo-button14 weight-500">{{ $t("storeSettings.headerTitle") }}</span>
          </router-link> -->
          <router-link v-if="!isGemPagesV7" :to="{ name: 'ActivityLog' }" @click.native="closeUserInfo" class="drop-down-menu d-flex align-items-center">
            <i class="icon icon-activity-log mr-2"></i>
            <span class="typo-button14 weight-500">{{ $t("storeSettings.eventLogs.title") }}</span>
          </router-link>

          <a target="_blank" :href="'https://' + shopInfo.shopifyDomain" class="drop-down-menu d-flex align-items-center">
            <i class="icon icon-live-view mr-2"></i>
            <span class="typo-button14 weight-500">{{ $t("generals.account.liveView") }}</span>
          </a>
        </div>
      </div>
    </div>
    <Portal to="tooltip-sidebar">
      <tooltip :pointer="true" :width="'auto'" />
      <!-- <tooltip :name="'noti'" :pointer="true" :width="'auto'" />
      <tooltip :name="'acc'" :pointer="true" :width="'auto'" />-->
    </Portal>
    <PlanModal />
  </header>

  <header class="sticky-menu" v-else>
    <div class="logo-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 820 200" width="160" fill="#fff" ><path class="cls-1" d="M208.56,65.75c20.87,0,38.33,13,42.23,31.59H236.27c-3.67-11-14.53-18.06-27.35-18.06-17.33,0-29.54,12.57-29.54,30.62s12,30.73,29.54,30.73c13.55,0,24.66-7.68,27.83-19.27H206.36V109.29H252c-.36,26.1-18.06,44.88-43.09,44.88S165.1,135.51,165.1,109.9C165.1,84.53,183.53,65.75,208.56,65.75Z"/><path class="cls-1" d="M259.46,119.66c0-19.76,14.65-34.52,33.93-34.52,20.15,0,33.57,15.49,33.57,34.64,0,1.46-.12,3-.24,4.51H273.25c1.59,10.61,9.28,17.2,20.14,17.2,7.82,0,14.29-3.66,17.7-9.64h14.29c-5.25,13.91-17.34,22.32-32,22.32C274.11,154.17,259.46,139.29,259.46,119.66Zm54-6.35c-2.44-10-10-16-20-16-10.25,0-17.57,6.09-19.89,16Z"/><path class="cls-1" d="M338.93,152.59V86.72h9.64l2.32,8.54a26.16,26.16,0,0,1,20.51-10c8.91,0,16,4.39,19.77,11.47a26,26,0,0,1,21.49-11.47c13.91,0,23.31,10.49,23.31,25.49v41.84H422.42V114.05c0-10.62-4.63-16.71-12.81-16.71-8.79,0-15.51,8-15.51,19.27v36H380.8V114.05c0-10.62-4.52-16.71-12.82-16.71-8.79,0-15.5,8-15.5,19.27v36Z"/><path class="cls-1" d="M453.06,152.59V67.21h31.62c16.48,0,29.05,12,29.05,28.17s-12.45,28.18-29.05,28.18H467.1v29Zm14-42.33H484c9.15,0,15.62-6.22,15.62-14.88S493.1,80.5,484,80.5H467.1Z"/><path class="cls-1" d="M519.59,119.66c0-19.88,14.77-34.52,34.43-34.52a33.21,33.21,0,0,1,24,9.76l1.59-8.18h10.5v65.87h-11l-1.34-8.05a32.75,32.75,0,0,1-23.8,9.63C534.36,154.17,519.59,139.41,519.59,119.66Zm13.8,0A21.1,21.1,0,0,0,555,141.24c12.45,0,21.49-9.14,21.49-21.58s-9-21.59-21.49-21.59A21.1,21.1,0,0,0,533.39,119.66Z"/><path class="cls-1" d="M602.11,118a32.9,32.9,0,0,1,56.64-22.69l2.2-8.54h8.91v57.21c0,21.1-12.57,33.9-33,33.9-16.84,0-28.81-8.78-32.22-23.29h13.55c2.56,7.32,10.25,11.22,18.55,11.22,11.48,0,19.78-7.44,19.78-20v-2.93a33.42,33.42,0,0,1-21.85,7.81A32.22,32.22,0,0,1,602.11,118Zm13.8,0c0,11.46,8.66,20.12,20.38,20.12s20.27-8.54,20.27-20.12S648,97.7,636.29,97.7,615.91,106.36,615.91,118Z"/><path class="cls-1" d="M681.83,119.66c0-19.76,14.64-34.52,33.93-34.52,20.14,0,33.57,15.49,33.57,34.64,0,1.46-.12,3-.24,4.51H695.62c1.59,10.61,9.28,17.2,20.14,17.2,7.81,0,14.28-3.66,17.7-9.64h14.28c-5.25,13.91-17.33,22.32-32,22.32C696.47,154.17,681.83,139.29,681.83,119.66Zm53.95-6.35c-2.44-10-10-16-20-16-10.25,0-17.58,6.09-19.9,16Z"/><path class="cls-1" d="M769.59,131.73c.37,7,6.23,10.49,14.17,10.49,7.2,0,12.81-3.05,12.81-8.54,0-6.22-7.08-7.68-15.13-9-11-1.83-23.93-4.39-23.93-19.64,0-11.83,10.25-19.88,25.51-19.88s25.27,8.29,25.51,21.1H795.72c-.25-6.34-5-9.64-12.94-9.64-7.57,0-12.21,3.18-12.21,7.93,0,5.86,6.84,7.08,14.77,8.3,11.11,2,24.66,4,24.66,20.24,0,12.81-10.74,21.1-26.73,21.1s-26.61-8.78-27-22.44Z"/><path class="cls-1" d="M150,22.22,10.76,65.75A1.11,1.11,0,0,0,10,67.13l10.74,35.29a1,1,0,0,0,1.32.72l102.15-32a19.21,19.21,0,0,0,11.35-9.53,226.48,226.48,0,0,0,15.64-38A1,1,0,0,0,150,22.22Z"/><path class="cls-1" d="M116.58,83.26l-86.5,27a1,1,0,0,0-.62,1.18l9.1,29.81a.93.93,0,0,0,1.13.61l55.16-17.26a16.43,16.43,0,0,0,9.61-8,186.5,186.5,0,0,0,13.19-32.17A.89.89,0,0,0,116.58,83.26Z"/><path class="cls-1" d="M83.68,137.77,47.63,149.06a.8.8,0,0,0-.51,1l7.67,25.2a.75.75,0,0,0,1,.51l9.57-3a13.94,13.94,0,0,0,8.13-6.82A157,157,0,0,0,84.6,138.75.73.73,0,0,0,83.68,137.77Z"/></svg>
    </div>
    <div class="container align-self-center">
      <div class="row">
        <div class="col-12">
          <article class="search-container search-holder"></article>
        </div>
      </div>
    </div>
    <div class="right-item">
      <div class="button">
        <i class="icon icon-help"></i>
      </div>
    </div>
    <div class="right-item">
      <div class="button">
        <i class="icon icon-notification"></i>
      </div>
    </div>
    <div class="right-item">
      <div class="button">
        <i class="icon icon-settings"></i>
      </div>
    </div>
    <div class="user-info user-holder">
      <div class="button">
        <!-- <div class="avatar">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.182 6.56802C13.4246 4.81066 10.5754 4.81066 8.81802 6.56802C7.06066 8.32537 7.06066 11.1746 8.81802 12.932C10.5754 14.6893 13.4246 14.6893 15.182 12.932C16.9393 11.1746 16.9393 8.32537 15.182 6.56802ZM16.2426 5.50736C13.8995 3.16421 10.1005 3.16421 7.75736 5.50736C5.41421 7.8505 5.41421 11.6495 7.75736 13.9926C10.1005 16.3358 13.8995 16.3358 16.2426 13.9926C18.5858 11.6495 18.5858 7.8505 16.2426 5.50736Z" fill="#E2E2E2" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.60139 20.3009C8.71319 16.2148 15.3588 16.2356 19.4449 20.3474L18.381 21.4047C14.8788 17.8806 9.18291 17.8627 5.65872 21.3649L5.65872 21.3649M5.65872 21.3649L5.6189 21.4047C5.32693 21.6985 4.85206 21.7 4.55825 21.408C4.26444 21.116 4.26295 20.6412 4.55493 20.3474L4.60139 20.3009L4.60139 20.3009" fill="#E2E2E2" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.4246 4.57538C15.3241 0.474873 8.67589 0.474873 4.57538 4.57538C0.474873 8.67589 0.474873 15.3241 4.57538 19.4246C8.67589 23.5251 15.3241 23.5251 19.4246 19.4246C23.5251 15.3241 23.5251 8.67589 19.4246 4.57538ZM20.4853 3.51472C15.799 -1.17157 8.20101 -1.17157 3.51472 3.51472C-1.17157 8.20101 -1.17157 15.799 3.51472 20.4853C8.20101 25.1716 15.799 25.1716 20.4853 20.4853C25.1716 15.799 25.1716 8.20101 20.4853 3.51472Z" fill="#E2E2E2" />
            <defs>
              <clipPath id="clip0">
                <path d="M0 0H24V24H0V0Z" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div> -->
        <div class="user-detail">
          <div class="user-name">
            <span class="typo-heading16 typo-medium skeleton-dark"></span>
          </div>
          <div class="shop-domain">
            <span class="typo-paragraph12 typo-regular skeleton-dark"></span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import UniversalSearch from "@/core/components/UniversalSearch";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import checkGlobalConfigs from "@/mixins/checkGlobalConfigs";
import PlanModal from "./Suggest/PlanModal.vue"
// import openFeedbackForm from "@/utils/satismeter";

export default {
  name: "Navigator",
  components: {
    UniversalSearch, 
    PlanModal,
  },
  mixins: [checkGlobalConfigs()],
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpenHelpCenter: false,
      isOpenUserInfo: false,
      shouldHighlight: false,
      timeout: null
    };
  },
  computed: {
    ...mapState({
      shopInfo: state => state.account.shopInfo
    }),
    ...mapGetters("notibar", {
      notiBar: "notiBar"
    }),
    ...mapState("agency", {
      agencyLogged: state => state.logged
    }),
    ...mapGetters("account", {
      shopPlan: "shopPlan",
      shopifyDomain: "shopifyDomain",
    }),
    allowNewPricing() {
      return this.isKeyValid("newPricing");
    },
    supportDropdownTitle() {
      if (this.allowNewPricing) {
        return this.$t("dashboard.support");
      }
      return this.$t("pricing.support");
    },
    isNotBusiness() {
      return this.allowNewPricing && ["starter"].includes(this.shopPlan);
    },
    emailSupportHref() {
      return `https://forms.clickup.com/f/3m5v4-12825/0NIHWZA25O919BHCL5?domain=${this.shopifyDomain}`
    },
    getTooltip() {
      return {
        helpCenter: this.isOpenHelpCenter ? false : this.$t("generals.helpCenter.toolTips")
      };
    },
    isGemPagesV7() {
      return (this && this.shopInfo && this.shopInfo.shopType && this.shopInfo.shopType.isGemPagesV7) || 
        window.___gemShopInfo.shopType.isGemPagesV7
    }
  },
  watch: {},
  created() {
    this.checkSwitched();
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
  methods: {
    ...mapActions("notibar", {
      openNotiCenter: "showNotificationBar",
      closeNotiCenter: "closeNotificationBar"
    }),
    ...mapActions("tutorial", {
      openFaqsModal: "openFaqsModal",
      openStartedGuide: "openStartedGuide"
    }),
    ...mapActions("agency", {
      openSwitchAgencyModal: "openSwitchAgencyModal"
    }),
    ...mapMutations("drawer", {
      setDisplayFeedbackMsg: "SET_DISPLAY_FEEDBACK"
    }),
    openNoti() {
      this.openNotiCenter();
      this.closeUserInfo();
      this.closeHelpCenter();
    },
    openHelpCenter() {
      this.isOpenHelpCenter = !this.isOpenHelpCenter;
      this.closeUserInfo();
      this.closeNotiCenter();
    },
    closeHelpCenter() {
      this.isOpenHelpCenter = false;
    },
    openUserInfo() {
      this.isOpenUserInfo = !this.isOpenUserInfo;
      this.closeHelpCenter();
      this.closeNotiCenter();
    },
    closeUserInfo() {
      this.isOpenUserInfo = false;
    },
    openLiveChat() {
      if (this.isNotBusiness) {
        this.$store.commit("account/SHOW_PLAN_MODAL");
      } else {
        this.$chatbox.show();
      }
      this.closeHelpCenter();
    },
    openFaqs() {
      this.openFaqsModal();
      this.closeHelpCenter();
    },
    openGuide() {
      this.openStartedGuide();
      this.closeHelpCenter();
    },
    openSwitchAgencyMenu() {
      this.openSwitchAgencyModal();
      this.closeUserInfo();
    },
    openVideoTutorials() {
      this.$router.push({ name: "Tutorials" });
      this.closeHelpCenter();
    },
    // handleOpenFeedback() {
    //   openFeedbackForm();
    //   this.setDisplayFeedbackMsg(false);
    //   this.closeHelpCenter();
    // },
    async checkSwitched() {
      let justSwitched = window.localStorage.justSwitched;
      if (justSwitched == true || justSwitched == "true") {
        this.isOpenUserInfo = true;
        await setTimeout(() => {}, 500);
        this.shouldHighlight = true;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.shouldHighlight = false;
          window.localStorage.removeItem("justSwitched");
        }, 5000);
      }
    },
    toggleGetHelp() {
      this.toggleGethelpModal(); // khi this.queryString ="" thì không submit
      if (this.isShowModal) {
        this.$customer.Track({
          behavior: "gethelpDashboard_openModal",
          data: JSON.stringify({
            page: window.location.pathname,
            open_type: "toggle"
          })
        });
      } else {
        this.$customer.Track({
          behavior: "gethelpDashboard_usedTime",
          data: JSON.stringify({
            page: window.location.pathname,
            used_time: this.getTimeUsingGetHelp,
            used_time_type: "toggle"
          })
        });
      }
    }
    // getTooltip(title){
    //   switch (title) {
    //     case "helpCenter":
    //       if (this.isOpenHelpCenter) {
    //         console.log("here");
    //         return false
    //       }
    //       console.log("here 2");
    //       return this.$t('generals.helpCenter.toolTips')
    //     case "userInfo":
    //       if (this.isOpenHelpCenter) {
    //         return false
    //       }
    //       return `$t('accountSettings.headerTitle')`
    //     default: return false
    //   }
    // }
  }
};
</script>
<style lang="scss" scoped>
// @import "@/core/themes/preload/navigator.scss";
.drop-down {
  &__diamond {
    width: 16px;
    height: 16px;
  }

  &__plan {
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
  }
}

i, svg.ico {
  font-size: 20px;
  color: $textDarkModeHigh;
}

.highlight {
  animation: blink 0.8s alternate linear infinite;
  position: relative;
  .highlight-tooltip {
    left: -194px;
    $pointer-size: 4px;

    font-size: 12px;
    line-height: 18px;
    background: $dark1;
    color: $textDarkModeHigh;
    padding: 3px 8px;
    max-width: 190px;
    position: absolute;
    border-radius: $radius;
    &:before {
      display: block;
      position: absolute;
      width: 0;
      height: 0;
      content: "";

      border-top: $pointer-size solid transparent;
      border-bottom: $pointer-size solid transparent;
      border-left: $pointer-size solid $dark1;
      right: -$pointer-size;
      top: calc(50% - #{$pointer-size});
    }
  }
}
.gethep_top-icon {
  color: $neutral5;
  &.showup {
    animation-name: action_show_up;
    animation-timing-function: linear;
    animation-duration: 1000ms;
    animation-delay: 0;
    // svg.showup-svg{
    //   animation-name: action_svg-show_up;
    //   animation-timing-function: linear;
    //   animation-duration: 1000ms;
    //   animation-delay: 0;
    //   transition: transform 500ms;
    // }
  }
}
@keyframes action_show_up {
  0% {
    background: #061325;
  }
  10% {
    background: #333;
  }
  100% {
    background: #333;
  }
}
@keyframes action_svg-show_up {
  0% {
    transform: rotate(90deg);
  }
  100% {
    transform: rotate(180deg);
  }
}
@keyframes blink {
  0% {
    box-shadow: unset;
  }
  50% {
    box-shadow: 0 0 7px 1px $accent-yellow;
  }
  100% {
    box-shadow: unset;
  }
}
</style>
